import React from 'react';
import { Heart, Shield, MapPin } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="py-20 bg-gradient-to-b from-yellow-50 to-white" data-testid="about-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-5 gap-12 items-center">
          {/* Image */}
          <div className="lg:col-span-2">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-yellow-400">
              <img
                src="https://customer-assets.emergentagent.com/job_4f54d655-dd2a-4e43-ada4-e31c895efef4/artifacts/r9cedsyj_View_recent_photos.png"
                alt="Ria, owner of Roll Up Lumpia Co."
                className="w-full h-full object-cover"
                data-testid="about-image"
              />
            </div>
          </div>

          {/* Content */}
          <div className="lg:col-span-3">
            <span className="inline-block bg-blue-600 text-white text-sm font-semibold px-4 py-1 rounded-full mb-4">
              Meet the Maker
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Hi, I'm Ria —
              <span className="block text-blue-700">the owner and heart behind Roll Up Lumpia Co.</span>
            </h2>

            {/* Badges */}
            <div className="flex flex-wrap gap-3 mb-6" data-testid="about-badges">
              <span className="flex items-center gap-2 bg-indigo-100 text-indigo-900 font-semibold px-4 py-2 rounded-full">
                <Heart className="h-4 w-4" /> Woman-Owned
              </span>
              <span className="flex items-center gap-2 bg-indigo-100 text-indigo-900 font-semibold px-4 py-2 rounded-full">
                <Shield className="h-4 w-4" /> Veteran-Backed
              </span>
              <span className="flex items-center gap-2 bg-indigo-100 text-indigo-900 font-semibold px-4 py-2 rounded-full">
                <MapPin className="h-4 w-4" /> El Mirage, AZ
              </span>
            </div>

            <div className="space-y-4 text-lg text-gray-800 leading-relaxed" data-testid="about-bio">
              <p>
                I'm a proud woman-owned, veteran-backed small business, rooted here in El Mirage, AZ
                with my husband and daughter. What started as a love for cooking and sharing culture
                has grown into something truly special.
              </p>
              <p>
                Every lumpia I make is crafted from scratch in my home kitchen under cottage food
                guidelines, with care in every step. I offer both frozen packs for you to enjoy anytime
                and freshly fried rolls ready to eat. Some of my recipes stay true to their authentic
                roots, while others bring a fun, modern twist to a classic favorite.
              </p>
              <p>
                You can often find me out in the community at local markets and events — I love connecting
                with people and sharing my food in person. Be sure to check out my social media to see
                where I'll be next!
              </p>
              <p>
                If you'd like to place an order, feel free to reach out by text, call, or email — all my
                contact information is listed at the bottom of this page.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
